import React, { useState, useEffect } from 'react';

// Import functions from components.js
import { isBritishCitizen, getParliamentaryTerms, hasCurrentTerm } from './components';

export const StartPetitionSection = ({ user, setCurrentPage }) => {
  const [canCreateToday, setCanCreateToday] = useState(true);
  const [parliamentInSession, setParliamentInSession] = useState(false); // Default to false
  const [termsLoading, setTermsLoading] = useState(true);

  useEffect(() => {
    if (user) {
      const today = new Date().toDateString();
      const petitionCountKey = `petition_count_${user.id}_${today}`;
      const todayCount = parseInt(localStorage.getItem(petitionCountKey) || '0', 10);
      setCanCreateToday(todayCount < 3); // Allow up to 3 petitions per day
    }
  }, [user]);

  // Load parliamentary terms to check if Parliament is in session
  useEffect(() => {
    const loadTerms = async () => {
      setTermsLoading(true);
      try {
        const fetchedTerms = await getParliamentaryTerms();
        const inSession = hasCurrentTerm(fetchedTerms);
        setParliamentInSession(inSession);
      } catch (error) {
        console.error('Error loading terms:', error);
        setParliamentInSession(false);
      } finally {
        setTermsLoading(false);
      }
    };

    loadTerms();
  }, []);

  return (
    <div className="bg-white pt-8 pb-12">
      <div className="container mx-auto px-4">
        <div className="border border-gray-200 rounded-lg bg-gray-50 p-6 md:p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-3">Start a petition</h2>

          {!canCreateToday && user && parliamentInSession && (
            <div className="mb-4 p-3 bg-orange-100 border border-orange-300 rounded-lg max-w-xl">
              <p className="text-orange-700 text-sm">
                <strong>Rate Limit:</strong> You can create 3 petitions per day
              </p>
            </div>
          )}

          <p className="text-gray-600 mb-6 max-w-2xl">
            {parliamentInSession
              ? "British citizens can create petitions. When you create a petition, you'll be the first to automatically sign it."
              : "Petitions can only be created when Parliament is in session. Please check back when the next parliamentary term begins."
            }
          </p>

          {user ? (
            isBritishCitizen(user) ? (
              <button
                onClick={() => setCurrentPage('create-petition')}
                disabled={termsLoading || !canCreateToday || !parliamentInSession}
                data-testid="start-petition-button"
                className={`px-6 py-3 rounded-lg font-medium transition-colors ${
                  (termsLoading || !canCreateToday || !parliamentInSession)
                    ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                    : 'bg-blue-600 text-white hover:bg-blue-700'
                }`}
              >
                {termsLoading ? 'Checking Parliament Status...' :
                 !parliamentInSession ? 'Parliament Not In Session' :
                 'Start a petition'}
              </button>
            ) : (
              <div>
                <p className="text-gray-600 mb-4">
                  You need to be a British Citizen to create petitions.
                </p>
                <button
                  disabled
                  className="bg-gray-300 text-gray-500 px-6 py-3 rounded-lg font-medium cursor-not-allowed"
                >
                  Connect Account to Start
                </button>
              </div>
            )
          ) : (
            <div>
              <p className="text-gray-600 mb-4">Connect your ROBLOX account to start creating petitions</p>
              <button
                disabled
                className="bg-gray-300 text-gray-500 px-6 py-3 rounded-lg font-medium cursor-not-allowed"
              >
                You are not a British citizen
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// Footer Component
